import { useCallback, useEffect, useRef, useState } from "react";
import MolGrid from "../../../components/Grid/MolGrid";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import { useNavigate } from "react-router-dom";
import { CriteriaListingData } from "./data/CriteriaListingData";
import { CriteriaListingConfig } from "./data/CriteriaListingConfig";
import { useGetAllCriteriaListMutation, useLazyGetAllDropdownForCRUDCategoryQuery } from "../../../app/services/Crud/crudApi";
import { setAllDropDownField } from "./Utils/dropdownUtils";
import { encryptAESID } from "../../../utils/Encryption";

const DEFAULT_PAGINATION = {
  pageNo: 1,
  pageSize: 10,
  totalCount: 0,
};

const CRUDCriteriaList = () => {
  const navigate = useNavigate();
  const molGridRef = useRef();
  const ViewApplicationRef = useRef();
  const [formData, setFormData] = useState(CriteriaListingData);
  const [dataSource, setDataSource] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState(DEFAULT_PAGINATION);
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getAllCriteriaList, { data: criteriaListData, isLoading: criteriaLoading },] = useGetAllCriteriaListMutation();

  useEffect(() => {
    getDropdowns();
    fetchRequirements(DEFAULT_PAGINATION);
  }, []);

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!criteriaLoading && criteriaListData) {
      setDataSource(criteriaListData?.itemList || []);
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: criteriaListData?.totalCount || 0,
      }));
    }
  }, [criteriaLoading, criteriaListData]);

  const fetchRequirements = useCallback((request) => {
    getAllCriteriaList(request);
  }, [getAllCriteriaList]);

  const handleSearch = useCallback(() => {
    const formValues = ViewApplicationRef.current?.getFormData();
    if (!formValues) return;

    const request = {
      ...DEFAULT_PAGINATION,
      CriteriaName: formValues?.searchByCriteriaName || null,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      StatusId: formValues?.statusId?.value || formValues?.statusId || null,
    };

    setPaginationRequest(request);
    fetchRequirements(request);
  }, [fetchRequirements]);

  const handleClearClick = useCallback(() => {
    const clearedForm = {
      ...CriteriaListingData,
      initialState: {
        requirementName: null,
        channel: null,
        statusId: null,
      },
    };

    setFormData(clearedForm);
    setPaginationRequest(DEFAULT_PAGINATION);
    fetchRequirements(DEFAULT_PAGINATION);
  }, [fetchRequirements]);

  const handlePageChange = useCallback(({ pageNumber, pageSize }) => {
    setPaginationRequest((prev) => {
      const updated = {
        ...prev,
        pageNo: pageNumber,
        pageSize,
      };
      fetchRequirements(updated);
      return updated;
    });
  }, [fetchRequirements]);
  // sgbpCriteriaId
  const handleAddRow = useCallback(() => {
    navigate("/addCriteria");
  });

  const handleEditCLick = (data) => {
    navigate(`/editCriteria/${encryptAESID(data?.sgbpCriteriaId)}`);
  }
  const handleDuplicateCLick = (data) => {
    navigate(`/duplicateCriteria/${encryptAESID(data?.sgbpCriteriaId)}`);
  }
  const actionHandler = {
    "Edit": handleEditCLick,
    "Duplicate": handleDuplicateCLick,
  }

  return (
    <div className="crud-requirement-list">
      <div className="corporate-member-list">
        <div className="member-list-filter row">
          <div className="row status-input col-12 pr-0">
            {dropdownData &&
              <FormCreator
                ref={ViewApplicationRef}
                {...formData}
              />
            }
          </div>
          <div className="crud-filter-right-side-btn col-6">
            <div className="crud-clear-filter">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="search-btn"
                onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary mb-2"
                onClick={handleClearClick}
              />
            </div>
            <Buttons
              buttonText="+ Add New"
              buttonTypeClassName="add-btn"
              onClick={handleAddRow}
            />
          </div>
        </div>

        <div className="member-list">
          <MolGrid
            ref={molGridRef}
            configuration={CriteriaListingConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
            isLoading={criteriaLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default CRUDCriteriaList;
